import React from "react";
import { NavMenuContext, NavMenuContextValue } from "./nav-menu-context";

/**
 * This is a custom hook to be used to access the context value of the nearest `NavMenuContextProvider` ancestor.
 */
export const useNavMenuContext = <P extends Record<string, unknown>>() => {
  const navMenuContextValue = React.useContext(NavMenuContext) as NavMenuContextValue<P>;
  if (!navMenuContextValue) {
    throw new Error(`useNavMenuContext can only be used within a NavMenuContext.Provider`);
  }
  return navMenuContextValue;
};
